export default "__VITE_ASSET__CCZDmb02__"